import { IsBoolean, IsEnum, IsOptional } from "class-validator";

export enum InteractivityUnitType {
	PERCENTAGES = 'percentages',
	PIXELS = 'pixels',
}

export class InteractivityDto {
	@IsOptional()
	@IsBoolean()
	enabled?: boolean;

	@IsOptional()
	@IsBoolean()
	dragInteractivity?: boolean;

	@IsOptional()
	@IsBoolean()
	resizeInteractivity?: boolean;

	@IsOptional()
	@IsBoolean()
	styleInteractivity?: boolean;

	@IsOptional()
	@IsEnum(InteractivityUnitType)
	dragUnit?: InteractivityUnitType;

	@IsOptional()
	@IsBoolean()
	highlighted?: boolean;
}

export const defaultEnabledInteractivityConfig = {
	enabled: true,
	dragInteractivity: true,
	resizeInteractivity: true,
	styleInteractivity: true
};

export const defaultDisabledInteractivityConfig = {
	enabled: false,
	dragInteractivity: false,
	resizeInteractivity: false,
	styleInteractivity: false
};
